import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle, faSync } from "@fortawesome/free-solid-svg-icons";
import { Button } from "../../../../components/common";
import styles from "./ErrorState.module.css";

const ErrorState = ({ error, onRetry }) => {
	return (
		<div className={styles.errorContainer}>
			<FontAwesomeIcon
				icon={faExclamationCircle}
				className={styles.errorIcon}
			/>
			<h3 className={styles.errorTitle}>Error Loading Logs</h3>
			<p className={styles.errorMessage}>
				{error?.message || "An error occurred while loading logs"}
			</p>
			<Button variant="primary" onClick={onRetry}>
				<FontAwesomeIcon icon={faSync} />
				Retry
			</Button>
		</div>
	);
};

export default ErrorState;
